module.exports = __webpack_public_path__ + "static/media/icons8-layout.dfbd5ea2.svg";